
import { call, put, takeEvery, all, fork } from "redux-saga/effects";

import {
  GET_ORG_SSO_STATUS,
  INVITE_CONFIRMATION, INVITE_CONFIRMATION_SUCCESS,
} from "./actionTypes";

import {
  inviteConfirmationSuccess, inviteConfirmationFail, getOrgSsoStatusFail, getOrgSsoStatusSuccess,
} from "./actions";

import {
  getOrgSsoStatusUrl,
  inviteConfirmationUrl
} from "../../helpers/fakebackend_helper";
import {resetPasswordSuccess} from "../auth/resetpassword/actions";

function* onInviteConfirmation({payload:data}) {
  try {
    const token = data.token;
    const password = data.password;
    const history = data.history;
    const response = yield call(inviteConfirmationUrl, token, {
      password: password
    });
    yield put(inviteConfirmationSuccess(response.message));
    setTimeout(()=> {
      history('/login');
    }, 4000);
  } catch (error) {
    yield put(inviteConfirmationFail(error.response.data.message));
  }
}

function* onGetOrgSSOStatus() {
  try {
    const response = yield call(getOrgSsoStatusUrl);
    yield put(getOrgSsoStatusSuccess(response['sso_login_only']));
  } catch (error) {
    yield put(getOrgSsoStatusFail(error.response.data.message));
  }
}

function* inviteConfirmationSaga() {
  yield takeEvery(INVITE_CONFIRMATION, onInviteConfirmation);
  yield takeEvery(GET_ORG_SSO_STATUS, onGetOrgSSOStatus);
}

export default inviteConfirmationSaga;
